import { shrpaApi } from "./axios";
import { ContentSummaryFullPayload, ContentSummaryPreviewPayload, ContentSummaryProcessingPayload } from "@contracts/contentCalendar";

export default {
  async getAllSummariesFull(customerId: string, justValid = true): Promise<ContentSummaryFullPayload> {
    const uri = `/content-summary/${customerId}/full?justValid=${justValid}`;
    const { data } = await shrpaApi.get<ContentSummaryFullPayload>(uri);
    return data;
  },

  async getAllSummariesPreview(customerId: string, justValid = true, includeExamples = false): Promise<ContentSummaryPreviewPayload> {
    const uri = `/content-summary/${customerId}/preview?justValid=${justValid}&includeExamples=${includeExamples}`;
    const { data } = await shrpaApi.get<ContentSummaryPreviewPayload>(uri);
    return data;
  },

  async getProcessingSummaries(customerId: string): Promise<ContentSummaryProcessingPayload> {
    const uri = `/content-summary/${customerId}/processing`;
    const { data } = await shrpaApi.get<ContentSummaryProcessingPayload>(uri);
    return data;
  },
};
